import styled from 'styled-components';
import Headline from 'components/Headline/styles';
import {DashboardHeader} from 'components/DashboardHeader/styles';

export const PageHeader = styled(DashboardHeader)`
  gap: 16px;
  margin-bottom: 32px;

  @media (max-width: 599px) {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
    margin-bottom: 16px;
  }
`;

export const TimePeriodWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 599px) {
    justify-content: space-between;
    width: 100%;
  }
`;

export const PageTitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PageTitle = styled(Headline)`
  margin: 0;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: #172751;
  margin: 0;
`;

export const TimePeriodLabel = styled.span`
  color: #172751;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
`;

export const Section = styled.section`
  margin-bottom: 24px;
`;

export const SectionHeader = styled.div`
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 130%;
  color: #2f3d48;
  margin: 0 0 12px;
`;

export const SectionSubtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: #172751;
  margin: 0;
`;

export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  @media (max-width: 1023px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 599px) {
    grid-template-columns: 1fr;
  }
`;

export const OpportunitiesRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
  }
`;

export const LocationsSection = styled.section`
  background: #ffffff;
  border-radius: 10px;
  padding: 46px 24px 24px;
  margin-bottom: 24px;
`;

export const LocationsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(340px, 370px) 1fr;
  gap: 24px;
  padding-top: 16px;

  @media (max-width: 899px) {
    grid-template-columns: 1fr;
  }
`;

export const TopCustomersSection = styled.section`
  background: #ffffff;
  border-radius: 10px;
  padding: 46px 24px 0 26px;
`;

export const TopCustomersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const ViewAllLink = styled.button`
  background: transparent;
  border: none;
  color: #ff2d38;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;
